import moment from 'moment';

export class DateUtil {

    /**
     * Returns the absolute month diff between start and end, with a minimum of 1
     * whenever both dates are provided. Returns null if either side is missing.
     *
     * The min-of-1 behaviour is intentional: short ranges (e.g. 16-03 → 19-03)
     * still need to count as one month of project duration.
     */
    public static diffInMonths(startDate: string | null , endDate: string | null ): number | null {
        if (!startDate || !endDate) {
            return null;
        }

        const start = moment(startDate);
        const end = moment(endDate);

        return Math.abs(Math.round(end.diff(start, 'M', true))) || 1;
    }
}
